import { usePortalAuth } from 'contexts/AuthPortalProvider';
import { useAuth } from 'contexts/AuthProvider';
import { useConfig } from 'contexts/ConfigProvider';
import Loading from 'pages/Loading';
import { lazy } from 'react';
import { BuildVersionList } from 'utils/helper';

/* portal */
const PortalLogin = lazy(() => import('pages/PortalLogin'));

/* contoller */
const Login = lazy(() => import('pages/Login'));

const RequirePortalAuth = ({ children }: { children: JSX.Element }) => {
  const { token } = usePortalAuth();

  if (!token) {
    return <PortalLogin />;
  }

  return children;
};

const RequireControllerAuth = ({ children }: { children: JSX.Element }) => {
  const { token } = useAuth();

  if (!token) {
    return <Login />;
  }

  return children;
};

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { buildVersion } = useConfig();

  return buildVersion ? (
    buildVersion === BuildVersionList.portal ? (
      <RequirePortalAuth>{children}</RequirePortalAuth>
    ) : (
      <RequireControllerAuth>{children}</RequireControllerAuth>
    )
  ) : (
    <Loading />
  );
};

export default RequireAuth;
